


























import { computed, defineComponent, ref, watch } from "@vue/composition-api";
import { UserVerificationStatus } from "@scrile/api-provider/dist/api/UserVerificationProvider";
import useAuthUser from "@/hooks/useAuthUser";
import useUserVerification from "@/hooks/useUserVerification";
import config from "@/config";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";
import BasePage from "@/components/BasePage";
import PayeeInfoSetupView from "./components/PayeeInfoSetupView.vue";
import PayeeInfoView from "./components/PayeeInfoView.vue";

export default defineComponent({
  name: "PagePayeeInfo",
  components: { PayeeInfoView, PayeeInfoSetupView, BasePage, BaseConfirm, BaseButton },
  setup(_, { root }) {
    const showContractConfirm = ref(false);

    const { findMyStatus } = useUserVerification();
    const { authUser, userVerificationStatus, isUnderage, parentalConsent } = useAuthUser();

    const showSetup = computed(
      () =>
        userVerificationStatus.value === UserVerificationStatus.UNVERIFIED && authUser.value?.role !== "talent_agent"
    );
    const creatorContractUrl = computed(() => config.creatorContractUrl);

    const getData = async () => {
      await findMyStatus();
    };

    watch(userVerificationStatus, newVal => {
      if (newVal === UserVerificationStatus.WAITING_FOR_APPROVAL && isUnderage.value && !parentalConsent.value) {
        root.$router.push({ name: "parentalConsent" });
      }
    });

    getData();

    return {
      showSetup,
      creatorContractUrl,
      showContractConfirm,
    };
  },
});
